import { render, staticRenderFns } from "./TrusteeToTrusteeTransferDetailsV2.vue?vue&type=template&id=62d90b6c&scoped=true"
import script from "./TrusteeToTrusteeTransferDetailsV2.vue?vue&type=script&lang=ts"
export * from "./TrusteeToTrusteeTransferDetailsV2.vue?vue&type=script&lang=ts"
import style0 from "./TrusteeToTrusteeTransferDetailsV2.vue?vue&type=style&index=0&id=62d90b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d90b6c",
  null
  
)

export default component.exports